import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Pagination, Radio, Row, Select, Space, Table, Tabs } from 'antd';
import { Badge } from 'flowbite-react';
import React, { useState } from 'react';
import { Link, useLoaderData, useNavigate } from 'react-router-dom';

const columns = [
  {
    title: 'Date',
    dataIndex: 'count_date',
    key: 'count_date',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    // render: (_, record) => <span>{record.count_date}</span>
  },
  {
    title: 'Reference',
    dataIndex: 'reference',
    key: 'reference',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Location',
    dataIndex: 'location',
    key: 'location',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Stock Count State',
    dataIndex: 'count_state',
    key: 'count_state',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    render: (_, record) => <Badge className={record.count_state === 'Waiting' ? "text-blue-600 bg-blue-100 w-max" : record.count_state === 'Submitted' && "text-green-950 bg-green-100 w-max"}>{record.count_state}</Badge>

  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    render: (_, record) => <Badge className={record.status === 'In Progress' ? "text-blue-600 bg-blue-100 w-max" : record.status === 'Validated' ? "text-green-950 bg-green-100 w-max" : record.status === 'Draft' && "text-slate-950 bg-slate-100 w-max"}>{record.status}</Badge>
  },
  {
    title: 'Action',
    key: 'operation',
    fixed: 'right',
    width: 100,
    className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
    render: (_, record) => (
      <Link className='h-full w-full' to={'/inventory/stock-counts/'+record.id}>
        EDIT
      </Link>
    )
  }
]



const StockCounts = () => {
  const counts = useLoaderData();
  const navigate = useNavigate();


  const onRow = (record, rowIndex) => {
    return {
      onClick: () => navigate('/inventory/stock-counts/'+record.id)
    };
  }

  return (
    <div>
      <div className='flex justify-between mx-4'>
        <h3 className='font-bold'>Stock Counts</h3>
        <div className=' bg-white dark:bg-gray-900'>
          {/* <Input addonBefore={<MdFilterAlt />}  defaultValue="mysite" /> */}

          <Select
            mode='multiple'
            size={'middle'}
            placeholder='Filter'
            // defaultValue={['a10', 'c12']}
            // onChange={handleChange}
            className='w-96'
            options={[]}
          />
        </div>
      </div>
      <div className='columns-2 mx-4 my-2'>
        <div className='column'>
          <Button className='' size={'sm'}>
            <Link to={'/inventory/stock-counts/new'} className='w-full'>New</Link>
          </Button>
        </div>
        <div className='dark:bg-gray-900 column'>
          <div className='flex justify-end'>
            <Pagination  total={50} />
          </div>
        </div>
      </div>
      <Table
        sticky
        key={'number'}
        onRow={onRow}
        rootClassName='hover:cursor-pointer'
        dataSource={counts}
        columns={columns}
        scroll={{ x: 1500 }}
        pagination={false}
      />
    
    </div>
  )
}

export default StockCounts;